import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.concat.js";

/*
 * @Author       : 程哲林
 * @Date         : 2023-08-29 15:35:05
 * @LastEditors: 邓鹏
 * @LastEditTime: 2026-07-03 11:15:26
 * @FilePath: /marketing-landing-fe/src/modules/landing/CourseSelection/methods/pay.ts
 * @Description  : 未添加文件描述
 */
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (g && (g = 0, op[0] && (_ = 0)), _) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { customError } from '@woulsl/sentry-config';
import Cookies from 'js-cookie';
import QS from 'qs';
import { isJoJoUp } from '@/const';
import { _trans } from '@/lib/i18next';
import AliPayModel from '@/plugins/aliPayModel'; // 获取支付参数

import Toast from '@/plugins/Toast';
import { generateShortUrl, getApolloKey } from '@/services/landing';
import { getTokenForBillCheckOut } from '@/services/pay';
import { billCheckOutByToken } from '@/services/pay';
import { decToBase32, getEnvEnum, getPathName, isAliPay, isApple, isJoJoBrowser, isJoJoReadBrowser, isWXAppBrowser, qsParse } from '@/utils';
import { getWxAndAliExist } from '@/utils/bridge';
import { loadAlipaySdk } from '@/utils/sdkLoader';
import PayMaskTip from '../../payMaskTip'; // 支付相关配置

var payBillcheckoutGrayscaleRes;

function payHit(data) {
  var nd = data;
  var userId = Cookies.get('uid') || '-1';
  var _a = qsParse().linkId,
      linkId = _a === void 0 ? '-1' : _a;
  var _b = nd.shunUserIds,
      shunUserIds = _b === void 0 ? [] : _b,
      _c = nd.shunLinkIds,
      shunLinkIds = _c === void 0 ? [] : _c;

  if (shunUserIds.includes(userId) || shunLinkIds.includes(linkId)) {
    nd.shunRate = 1;
  }

  return nd;
}

export function payBillcheckoutGrayscale() {
  return __awaiter(this, void 0, void 0, function () {
    var activityPriceContent, activitySkuName, iapWhitelist, tenantIapRate, shunRateRes, res, error_1, shunRateRes, res, e_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!isJoJoUp) return [3
          /*break*/
          , 5];
          activityPriceContent = {};
          activitySkuName = {};
          iapWhitelist = [];
          tenantIapRate = {
            jojoup: 0
          };
          _a.label = 1;

        case 1:
          _a.trys.push([1, 3,, 4]);

          return [4
          /*yield*/
          , getApolloKey('pay.billcheckout.Grayscale')];

        case 2:
          shunRateRes = _a.sent();

          if (shunRateRes.data) {
            res = JSON.parse(shunRateRes.data);
            activityPriceContent = res.activityPriceContent;
            activitySkuName = res.activitySkuName;
            iapWhitelist = res.iapWhitelist;
            tenantIapRate = res.tenantIapRate;
          }

          return [3
          /*break*/
          , 4];

        case 3:
          error_1 = _a.sent();
          console.log(error_1);
          return [3
          /*break*/
          , 4];

        case 4:
          return [2
          /*return*/
          , {
            shunRate: 1,
            iapWhitelist: iapWhitelist,
            tenantIapRate: tenantIapRate,
            channelToCreateOrderContent: [],
            activityPriceContent: activityPriceContent,
            activitySkuName: activitySkuName
          }];

        case 5:
          if (payBillcheckoutGrayscaleRes) {
            return [2
            /*return*/
            , payHit(payBillcheckoutGrayscaleRes)];
          }

          _a.label = 6;

        case 6:
          _a.trys.push([6, 8,, 9]);

          return [4
          /*yield*/
          , getApolloKey('pay.billcheckout.Grayscale')];

        case 7:
          shunRateRes = _a.sent();

          if (shunRateRes.data) {
            res = JSON.parse(shunRateRes.data);
            payBillcheckoutGrayscaleRes = payHit(res);
            return [2
            /*return*/
            , payBillcheckoutGrayscaleRes];
          }

          return [3
          /*break*/
          , 9];

        case 8:
          e_1 = _a.sent();
          console.error(e_1);
          return [3
          /*break*/
          , 9];

        case 9:
          return [2
          /*return*/
          , {
            shunRate: 0,
            iapWhitelist: [],
            channelToCreateOrderContent: [],
            activityPriceContent: {}
          }];
      }
    });
  });
}
export function getFreeBtnText(channel, channelToCreateOrderContent) {
  if (channel === void 0) {
    channel = '';
  }

  var freeBtnText = {
    showPrice: true,
    createOrderContent: _trans('courseSelection.free.btn')
  }; // 在叫叫体系内，不是叫叫阅读APP内

  if (isJoJoBrowser() && !isJoJoReadBrowser() && isApple()) {
    freeBtnText = {
      showPrice: false,
      createOrderContent: '立即领取'
    };
  } else if (channelToCreateOrderContent) {
    var item = channelToCreateOrderContent.find(function (_a) {
      var channels = _a.channels; // const chl = channel.replace(/-.*$/, '');

      return channels.includes(channel);
    });

    if (item) {
      var showPrice = item.showPrice,
          createOrderContent = item.createOrderContent;
      freeBtnText = {
        showPrice: showPrice,
        createOrderContent: createOrderContent
      };
    }
  }

  return freeBtnText;
}
export var getPayParams = function getPayParams(_a) {
  var payWay = _a.payWay,
      preOrderId = _a.preOrderId,
      scanPayMethods = _a.scanPayMethods,
      backUrl = _a.backUrl,
      payEnv = _a.payEnv,
      alipayExist = _a.alipayExist;
  return __awaiter(void 0, void 0, void 0, function () {
    var paramPayWay, baseParams, redirectUrl, shortUrlRes, shortUrl, error_2, params;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          paramPayWay = payWay;
          baseParams = {
            bizId: preOrderId,
            bizType: 'PRE'
          };
          redirectUrl = backUrl;
          if (![110, 111, 112].includes(payWay)) return [3
          /*break*/
          , 6]; // 微信内支付backUrl传空避免在外部浏览器内走后续流程

          if (isWXAppBrowser()) {
            redirectUrl = '';
          } else {
            redirectUrl += '&aliStatus=success';
          }

          _b.label = 1;

        case 1:
          _b.trys.push([1, 4,, 5]);

          if (!((redirectUrl === null || redirectUrl === void 0 ? void 0 : redirectUrl.length) && (redirectUrl === null || redirectUrl === void 0 ? void 0 : redirectUrl.length) > 400)) return [3
          /*break*/
          , 3];
          return [4
          /*yield*/
          , generateShortUrl({
            url: redirectUrl
          })];

        case 2:
          shortUrlRes = _b.sent();
          shortUrl = ((shortUrlRes === null || shortUrlRes === void 0 ? void 0 : shortUrlRes.data) || {}).shortUrl;

          if (shortUrl) {
            redirectUrl = shortUrl;
          }

          _b.label = 3;

        case 3:
          return [3
          /*break*/
          , 5];

        case 4:
          error_2 = _b.sent();
          console.log(error_2);
          return [3
          /*break*/
          , 5];

        case 5:
          if (!alipayExist || payEnv === 2) {
            // 小程序内指定为扫码付
            // app内只有这几种原生支付方式
            paramPayWay = scanPayMethods && scanPayMethods.code || 111;
          }

          _b.label = 6;

        case 6:
          params = __assign(__assign({}, baseParams), {
            payWay: paramPayWay,
            payEnv: payEnv,
            backUrl: redirectUrl
          });
          return [2
          /*return*/
          , params];
      }
    });
  });
}; // 支付宝token支付

export var aliPreparePay = function aliPreparePay(_a) {
  var token = _a.token,
      onSuccess = _a.onSuccess,
      onFail = _a.onFail,
      _b = _a.alipayExist,
      alipayExist = _b === void 0 ? true : _b,
      payEnv = _a.payEnv,
      onScanModalShow = _a.onScanModalShow,
      onScanModalClose = _a.onScanModalClose;
  return __awaiter(void 0, void 0, void 0, function () {
    var ok, apSdk, url, pathname, _c, resData, errorMsg, _d, data, payWay, amount, content, formWrap, existForm, form;

    return __generator(this, function (_e) {
      switch (_e.label) {
        case 0:
          if (!token) {
            Toast.fail('没获取到支付token', 2);
            if (onFail) onFail();
            return [2
            /*return*/
            ];
          }

          if (!isAliPay()) return [3
          /*break*/
          , 2];
          return [4
          /*yield*/
          , Promise.race([loadAlipaySdk(), new Promise(function (resolve) {
            setTimeout(function () {
              return resolve(false);
            }, 5000);
          })])];

        case 1:
          ok = _e.sent();
          apSdk = window.ap;

          if (!ok || !apSdk) {
            Toast.fail('支付环境加载失败，请重试', 2);
            if (onFail) onFail();
            return [2
            /*return*/
            ];
          }

          url = "/aliPay.html?token=".concat(token);
          pathname = getPathName(url);
          apSdk.pushWindow(pathname);
          return [2
          /*return*/
          ];

        case 2:
          return [4
          /*yield*/
          , billCheckOutByToken({
            token: token
          })];

        case 3:
          _c = _e.sent(), resData = _c.data, errorMsg = _c.errorMsg;
          _d = resData || {}, data = _d.data, payWay = _d.payWay;

          if (!resData || !data) {
            Toast.fail(errorMsg || '系统开小差啦', 2);
            if (onFail) onFail();
            return [2
            /*return*/
            ];
          }

          amount = data.amount, content = data.content;

          if (!content) {
            Toast.fail('创建支付宝预付单失败!', 1);
            if (onFail) onFail();
            return [2
            /*return*/
            ];
          }

          if (onSuccess) onSuccess();

          if (payWay === 140) {
            // 如果是中行
            window.location.replace(content);
          }

          if (alipayExist && payEnv !== 2) {
            formWrap = document.getElementById('punchout_form_wrap');
            existForm = !!formWrap;

            if (!formWrap) {
              formWrap = document.createElement('div');
              formWrap.id = 'punchout_form_wrap';
            }

            formWrap.innerHTML = content;

            if (!existForm) {
              document.body.appendChild(formWrap);
            }

            form = document.forms.namedItem('punchout_form');
            form === null || form === void 0 ? void 0 : form.submit();
          } else {
            Toast.hide(); // 展示弹窗支付

            AliPayModel.show({
              payUrl: content,
              price: amount,
              onCancel: onScanModalClose,
              onClose: onScanModalClose
            });

            if (onScanModalShow) {
              onScanModalShow();
            }
          }

          return [2
          /*return*/
          ];
      }
    });
  });
};

var replaceHistoryState = function replaceHistoryState(query) {
  if (!query) return;
  var _a = window.location,
      origin = _a.origin,
      pathname = _a.pathname;
  var newUrl = "".concat(origin).concat(pathname, "?").concat(QS.stringify(query));
  window.history.replaceState({
    path: newUrl
  }, '', newUrl);
}; // 支付宝支付


export var toPayByAli = function toPayByAli(_a) {
  var preOrderId = _a.preOrderId,
      soldId = _a.soldId,
      checkCode = _a.checkCode,
      payToken = _a.payToken,
      itemIndex = _a.itemIndex,
      newPop = _a.newPop,
      phoneCode = _a.phoneCode,
      query = _a.query,
      getOrderInfo = _a.getOrderInfo,
      cancelGetOrderInfo = _a.cancelGetOrderInfo;
  return __awaiter(void 0, void 0, void 0, function () {
    var payEnv, alipayExist, phone, code, verify, areaCode, bPhone, phoneParam, existQuery, _b, enPrm, rest, _c, origin, pathname, redirectUrl, payParams, aliToken;

    return __generator(this, function (_d) {
      switch (_d.label) {
        case 0:
          return [4
          /*yield*/
          , getEnvEnum()];

        case 1:
          payEnv = _d.sent();
          return [4
          /*yield*/
          , getWxAndAliExist(110)];

        case 2:
          alipayExist = _d.sent().alipayExist;
          phone = phoneCode.phone, code = phoneCode.code, verify = phoneCode.verify, areaCode = phoneCode.areaCode, bPhone = phoneCode.bPhone;
          phoneParam = bPhone ? {
            bPhone: bPhone
          } : {
            vPhone: decToBase32(phone)
          };
          existQuery = qsParse();
          _b = existQuery || {}, enPrm = _b.enPrm, rest = __rest(_b, ["enPrm"]);
          _c = window.location, origin = _c.origin, pathname = _c.pathname;
          redirectUrl = "".concat(origin).concat(pathname, "?").concat(QS.stringify(__assign(__assign(__assign({}, rest || {}), phoneParam), {
            preOId: preOrderId,
            ordId: soldId,
            chCode: checkCode,
            pToken: payToken,
            vCode: code,
            vVerify: verify,
            vAreaCode: areaCode,
            itemIndex: itemIndex,
            np: newPop ? 1 : ''
          })));
          return [4
          /*yield*/
          , getPayParams({
            preOrderId: preOrderId,
            payWay: 110,
            payEnv: payEnv,
            alipayExist: alipayExist,
            backUrl: redirectUrl
          })];

        case 3:
          payParams = _d.sent();
          return [4
          /*yield*/
          , getTokenForBillCheckOut(payParams)];

        case 4:
          aliToken = _d.sent().data; // 微信浏览器内展示引导弹窗

          if (isWXAppBrowser()) {
            Toast.hide();
            PayMaskTip.show({
              onClick: function onClick() {
                replaceHistoryState(query);
              }
            });
            replaceHistoryState(__assign(__assign({}, query), {
              aliToken: aliToken
            }));
            setTimeout(function () {
              PayMaskTip.hide();
              replaceHistoryState(query);
            }, 5000);
            setTimeout(function () {
              getOrderInfo(soldId, checkCode);
            }, 1500);
            return [2
            /*return*/
            ];
          }

          aliPreparePay({
            token: aliToken,
            alipayExist: alipayExist,
            payEnv: payEnv,
            onScanModalShow: function onScanModalShow() {
              return getOrderInfo(soldId, checkCode, true);
            },
            onScanModalClose: cancelGetOrderInfo
          });
          return [2
          /*return*/
          ];
      }
    });
  });
};
export var getWxPayRedirectUrl = function getWxPayRedirectUrl(params) {
  if (params === void 0) {
    params = {};
  }

  var _a = window.location,
      origin = _a.origin,
      pathname = _a.pathname;
  var query = qsParse();
  delete query.aliToken;
  delete query.aliStatus;
  delete query.shareUrl;
  delete query.shareImage;
  delete query.shareTitle;

  var newQuery = __assign(__assign({}, query), params || {});

  return "".concat(origin).concat(pathname, "?").concat(QS.stringify(newQuery));
}; // ===== 虚拟支付相关 =====
// 虚拟支付常量

export var VIRTUAL_PAY_PLATFORM = 20;
export var VIRTUAL_PAY_APP = 13;
export var VIRTUAL_PAY_WAY = 103; // 缓存 linkId 白名单

var virtualPayLinkIds = null;
/**
 * 获取虚拟支付 linkId 白名单（Apollo: wx.virtualPay.linkIds）
 */

export function getVirtualPayLinkIds() {
  return __awaiter(this, void 0, void 0, function () {
    var res, e_2;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (virtualPayLinkIds) return [2
          /*return*/
          , virtualPayLinkIds];
          _a.label = 1;

        case 1:
          _a.trys.push([1, 3,, 4]);

          return [4
          /*yield*/
          , getApolloKey('wx.virtualPay.linkIds')];

        case 2:
          res = _a.sent();

          if (res === null || res === void 0 ? void 0 : res.data) {
            virtualPayLinkIds = JSON.parse(res.data);
          }

          return [3
          /*break*/
          , 4];

        case 3:
          e_2 = _a.sent();
          customError({
            name: '虚拟支付白名单获取失败',
            message: (e_2 instanceof Error ? e_2.message : String(e_2)) || 'getVirtualPayLinkIds error',
            captureContext: {
              level: 'warning'
            }
          });
          return [3
          /*break*/
          , 4];

        case 4:
          return [2
          /*return*/
          , virtualPayLinkIds || []];
      }
    });
  });
}
/**
 * 虚拟支付基础资格判断（不依赖 price/needShip）
 * 用于 showDetail 阶段，此时 SKU 详情尚未返回，仅判断环境 + 白名单
 * 条件：小程序环境 AND !applePayCfg(IAP隔离) AND linkId命中白名单
 */

export function isVirtualPayBaseEligible(params) {
  return __awaiter(this, void 0, void 0, function () {
    var isMiniProgram, applePayCfg, linkId, linkIds;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          isMiniProgram = params.isMiniProgram, applePayCfg = params.applePayCfg, linkId = params.linkId;
          if (!isMiniProgram) return [2
          /*return*/
          , false];
          if (applePayCfg) return [2
          /*return*/
          , false]; // IAP 隔离

          return [4
          /*yield*/
          , getVirtualPayLinkIds()];

        case 1:
          linkIds = _a.sent();
          return [2
          /*return*/
          , linkIds.includes(linkId)];
      }
    });
  });
}
/**
 * 判断是否应使用虚拟支付
 * 条件：小程序环境 AND !applePayCfg(IAP隔离) AND !needShip AND price > 0 AND linkId命中白名单
 */

export function shouldUseVirtualPayment(params) {
  return __awaiter(this, void 0, void 0, function () {
    var needShip, price;
    return __generator(this, function (_a) {
      needShip = params.needShip, price = params.price;
      if (needShip) return [2
      /*return*/
      , false];
      if (price <= 0) return [2
      /*return*/
      , false];
      return [2
      /*return*/
      , isVirtualPayBaseEligible(params)];
    });
  });
}